import { Salesforce } from 'mxp-schemas';

type CenterMembership = {
  id: string;
  firmMembershipType: string;
};
export interface Organization {
  id: string;
  parentId?: string | null;
}
export interface FirmMembership {
  accountKey: string;
  firmMembershipType: string | null | undefined;
  status?: string | null;
  admin?: { parentId?: string | null };
}

const INACTIVE_CENTER_MEMBERSHIP_STATUSES = new Set<string>([
  Salesforce.MembershipStatus.RESIGNED,
  Salesforce.MembershipStatus.TERMINATED,
]);

export const pickMembershipBySlug = (
  memberships: CenterMembership[] | undefined,
  productSlug?: string
): CenterMembership | null => {
  if (!memberships?.length || !productSlug) return null;

  const keyword = productSlug.toUpperCase();
  return memberships.find(m => (m.firmMembershipType || '').toUpperCase().includes(keyword)) ?? null;
};

export const normalizeType = (s?: string | null): string => (s ? (s.split(' - ')[0] || s).trim().toUpperCase() : '');

export function findOrganizationMembership(
  organization: { id?: string | null; parentId?: string | null },
  memberships: ReadonlyArray<FirmMembership>,
  userChoiceType: string | null | undefined
): FirmMembership | null {
  const orgId = organization?.id;
  const parentId = organization?.parentId ?? null;
  const userChoiceNorm = normalizeType(userChoiceType);

  if (!orgId || !userChoiceNorm) return null;

  const found = memberships.find(m => {
    const mType = normalizeType(m?.firmMembershipType);
    if (mType !== userChoiceNorm) return false;
    if (m.status && INACTIVE_CENTER_MEMBERSHIP_STATUSES.has(m.status)) return false;

    const matchesSame = m.accountKey === orgId;
    const matchesParent = !!parentId && (m.accountKey === parentId || m.admin?.parentId === parentId);
    const matchesChild = m.admin?.parentId === orgId;

    return matchesSame || matchesParent || matchesChild;
  });
  return found ?? null;
}

export const isPositiveIntString = (v: string): boolean => /^(?!-)[1-9]\d*$/.test(v);

export const isPcpsCpaOwnersValid = (ownersRaw: string | null | undefined, totalCpasRaw: string | number): boolean => {
  const owners = (ownersRaw ?? '').trim();
  const totalCpas = Number(totalCpasRaw);

  if (!Number.isFinite(totalCpas)) return false;
  if (!isPositiveIntString(owners)) return false;

  return Number(owners) <= totalCpas;
};

export const isOptionalPositiveIntValid = (raw: string | null | undefined): boolean => {
  const v = (raw ?? '').trim();
  if (!v.length) return true;
  return isPositiveIntString(v);
};
